require('/ui/components/taskflow/layoutHeaderMobile/layoutHeaderMobile.module.scss.module.css');

export const container = "_container_4091w_1";
export const headerContainer = "_header-container_4091w_1";
export const titleContainer = "_title-container_4091w_1";
export const title = "_title_4091w_1";
export const smallViewportSupport = "_small-viewport-support_4091w_1";
export const description = "_description_4091w_1";
export const resourcelink = "_resourcelink_4091w_1";
export const resourcelinkDisplayText = "_resourcelink-display-text_4091w_1";
export const headerCtas = "_header-ctas_4091w_1";
export const tabLabel = "_tab-label_4091w_1";
export const contentBody = "_content-body_4091w_1";
export const cta = "_cta_4091w_1";
export const buttonLabel = "_button-label_4091w_1";
